import { usePathAndData } from "../../../hook/usePathAndData";
import { AppLayout } from "../../layout/AppLayout";
import { CambioClave } from "../../view/admins/CambioClave";
import { ListaAdmins } from "../../view/admins/ListaAdmins";


export const PageAdmin = () => {
    const { path, dataValue } = usePathAndData(); // Usa el hook
    return (
        <AppLayout>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="card">
                            <div className="card-body" style={{ borderRadius: "13px" }}>
                                {path[1] === "admins" && path[2] === "lista" && <ListaAdmins />}
                                {path[1] === "admins" && path[2] === "cambioContrasena" && <CambioClave />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
};
